import get from "lodash/get";
import { i18n } from "i18n";
import {
  IBreadcrumbBarItem,
  IConfirmationPopupTexts,
  ITitaniumUploaderTexts,
} from "component-library";

import { ISelfTapeRequest } from "shared/models/selfTapeRequest";
import { PageTitleKey } from "config/common";

import PageKey from "config/PageKey";

import {
  ICommonTranslation,
  ISelfTapeUploadPageTranslation,
} from "models/translation";
import defaultsWithFallback from "helpers/defaultsWithFallback";
import { getPageTitle } from "helpers/getPageTitle";
import { fallbackTranslation } from "services/api/fallbackData";

import applicationMap from "services/applicationMap";
import { ISelfTapeUploadPageTexts } from "./SelfTapeUploadPage";

const fallbackPageTranslation = fallbackTranslation[PageKey.SelfTapeUpload];

export const breadcrumbsKeys = {
  myAccount: "MyAccount",
  selfTapeRequests: "SelfTapeRequests",
};

export function prepareTexts(
  pageTranslation: ISelfTapeUploadPageTranslation,
  commonTranslation: ICommonTranslation,
  selfTapeRequest: ISelfTapeRequest
): ISelfTapeUploadPageTexts {
  const texts = defaultsWithFallback(pageTranslation, fallbackPageTranslation);

  return {
    ...texts,
    pageTitle: getPageTitle(
      commonTranslation,
      PageTitleKey.SelfTapeAddVideo,
      (format) => format.replace("{selfTapeName}", selfTapeRequest.title)
    ),
  };
}

export function prepareBreadcrumbs(
  selfTapeRequest: ISelfTapeRequest,
  accountUrl: string,
  performerRequestId: string
): IBreadcrumbBarItem[] {
  const { t } = i18n;
  const selfTapeRequestsLink = applicationMap.links.jobsSelfTapeRequests();
  const selfTapeRequestLink =
    applicationMap.links.selfTapeRequest(performerRequestId);

  return [
    {
      text: t("common:nav.links.home"),
      url: accountUrl,
    },
    {
      text: t("common:mediaRequest.page.breadcrumbs.mediaRequest"),
      url: selfTapeRequestsLink,
    },
    {
      text: selfTapeRequest.title,
      url: selfTapeRequestLink,
    },
  ];
}

export function getUploaderTexts(
  texts: ISelfTapeUploadPageTranslation
): ITitaniumUploaderTexts {
  return {
    dropzoneLabel: texts.body.dropzoneLabel,
    preview: {
      formatValidationError: texts.body.formatValidationError,
      uploadError: texts.body.uploadError,
    },
  };
}

export function getConfirmationPopupTexts(
  texts: ISelfTapeUploadPageTranslation
): IConfirmationPopupTexts {
  return {
    cancel: texts.closeAlert.closePopupButtonText,
    proceed: texts.closeAlert.proceedButtonText,
    description: texts.closeAlert.closeAlertText,
    title: texts.closeAlert.closeAlertTitle,
  };
}

export enum MediaErrorPopupType {
  ExceedLimit = "ExceedLimit",
  NotUploaded = "NotUploaded",
}

export function getMediaPopupTexts(
  texts: ISelfTapeUploadPageTranslation,
  popupType: MediaErrorPopupType
) {
  const titlePath = `media${popupType}Alert.media${popupType}AlertTitle`;
  const bodyPath = `media${popupType}Alert.media${popupType}AlertText`;
  const closeButtonTextPath = `media${popupType}Alert.media${popupType}AlertCloseButtonText`;

  return {
    title: get(texts, titlePath),
    description: get(texts, bodyPath),
    closeButtonText: get(texts, closeButtonTextPath),
  };
}
